import axios from 'axios';

let queue: { [k: string]: [] } = {
  'page': [],
  'track': [],
  'identify': [],
};

const postPayload = async (url: string, action: string, payloads: string[]) => {
  const payloadsEncoded = payloads.map(payload => JSON.stringify(payload));

  try {
    return await axios.post(
      `${url}/${action}`,
      {
        data: payloadsEncoded
      });
  } catch (error) { console.log(error)}
  return null;
}

function workQueue(url: string) {
  for (const [queueName, payloads] of Object.entries(queue)) {
    if (payloads.length) {
      postPayload(url, queueName, payloads)
      queue[queueName] = [];
    }
  }
}

export default function OPPAnalytics({
  url,
  name = "opp-analytics",
}: {url: string; name: string}) {
  return {
    /* All plugins require a name */
    name: name,
    initialize: () => {
      setInterval(workQueue, 2000, url);
    },
    page: ({payload}) => {
      const payloadFormatted = {
        page: payload.properties.path
      }
      queue['page'].push(payloadFormatted);
    },
    track: ({payload}) => {
      const payloadFormatted = {
        event: payload.event,
        value: payload.properties.value,
      }
      queue['track'].push(payloadFormatted);
    },
    identify: ({payload}) => {
      queue['identify'].push(payload);
    },
    loaded: () => {
      // return boolean so analytics knows when it can send data to third-party
      return true;
    }
  }
}
